import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#D4AF37', // Luxury gold
      light: '#F4D03F',
      dark: '#B8941E',
      contrastText: '#000000',
    },
    secondary: {
      main: '#D4AF37', // Gold accent
      light: '#F4D03F',
      dark: '#B8941E',
      contrastText: '#000000',
    },
    background: {
      default: '#0A0A0A',
      paper: '#121212',
      dark: '#000000',
      light: '#1A1A1A',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0B0B0',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
    },
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
      letterSpacing: '-0.01em',
    },
    subtitle1: {
      letterSpacing: '-0.01em',
    },
    body1: {
      letterSpacing: '-0.005em',
    },
    body2: {
      letterSpacing: '-0.005em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '14px 40px',
          fontSize: '0.95rem',
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        },
        contained: {
          boxShadow: 'none',
          background: 'linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%)',
          color: '#000000',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(212, 175, 55, 0.4)',
            transform: 'translateY(-2px)',
            background: 'linear-gradient(135deg, #F4D03F 0%, #D4AF37 100%)',
          },
        },
        outlined: {
          borderWidth: '2px',
          borderColor: '#D4AF37',
          color: '#D4AF37',
          '&:hover': {
            borderWidth: '2px',
            borderColor: '#F4D03F',
            backgroundColor: 'rgba(212, 175, 55, 0.1)',
            color: '#F4D03F',
          },
        },
        sizeLarge: {
          padding: '18px 48px',
          fontSize: '1rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: 'none',
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          backgroundColor: '#121212',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 16px 48px rgba(212, 175, 55, 0.15)',
            borderColor: 'rgba(212, 175, 55, 0.6)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#000000',
          borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            transition: 'all 0.3s ease',
            backgroundColor: '#1A1A1A',
            color: '#FFFFFF',
            '& fieldset': {
              borderColor: 'rgba(212, 175, 55, 0.3)',
            },
            '&:hover': {
              '& fieldset': {
                borderColor: '#D4AF37',
              },
            },
            '&.Mui-focused': {
              '& fieldset': {
                borderWidth: '2px',
                borderColor: '#D4AF37',
              },
            },
          },
          '& .MuiInputLabel-root': {
            color: '#B0B0B0',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#D4AF37',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width: 1200px)': {
            maxWidth: 1280,
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: '12px 24px',
        },
      },
    },
  },
  shape: {
    borderRadius: 0,
  },
  shadows: [
    'none',
    '0 2px 8px rgba(0, 0, 0, 0.8)',
    '0 4px 16px rgba(0, 0, 0, 0.8)',
    '0 8px 24px rgba(0, 0, 0, 0.8)',
    '0 12px 32px rgba(0, 0, 0, 0.8)',
    '0 16px 40px rgba(0, 0, 0, 0.9)',
    '0 20px 48px rgba(0, 0, 0, 0.9)',
    '0 24px 56px rgba(0, 0, 0, 0.9)',
    ...Array(17).fill('0 24px 56px rgba(0, 0, 0, 0.9)'),
  ],
});

export default theme; 